export class Features {

  static init(features) {
    sessionStorage.setItem("features", JSON.stringify(features));
  }

  static get(key) {

    if (typeof sessionStorage === "undefined") {
      return false;
    }

    const features = sessionStorage.getItem("features");

    if (!key || !features) {
      return false;
    }

    const jsonFeatures = JSON.parse(features);

    return jsonFeatures[key] || false;
  }
}